/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_PLANTINGS_ITEM = {
  id: 'agro_cultivos_main',
  screenId: 'agr-cul-plantings',
  label: 'Cultivos (siembras)',
  description: 'Siembras anuales y plantaciones perennes: alta, temporadas y detalle con eventos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá registrás cada siembra anual o plantación perenne: qué cultivo, en qué campo o zona, superficie y estado. Es el punto de partida para riego, fertilización y eventos.',
      },
      {
        title: 'Antes de empezar',
        bullets: [
          'Tené al menos un campo (y zona si aplica) en Agro → Campos.',
          'Para anuales: creá una campaña en «Campañas».',
          'El cultivo debe existir en «Configuración» (catálogo), con ciclo Anual o Perenne.',
        ],
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          {
            label: 'Campaña',
            description: 'Filtra siembras anuales de esa campaña y plantaciones perennes que tengan temporada en esa campaña. «Todas» muestra todo.',
          },
          {
            label: 'Campo / Zona',
            description: 'Elegí el lugar. Sin campo (o zona) no se listan siembras.',
          },
        ],
      },
      {
        title: 'Paso 2 — Lista',
        bullets: [
          'Columnas: Campaña/temporada, Cultivo, Fecha, Superficie (ha), Estado, Efic. riego.',
          'Tocá una fila para ver el detalle (y, en perennes, abrir temporadas).',
          'Lápiz = editar; tachito = eliminar.',
          'El botón + abre el alta.',
        ],
      },
      {
        title: 'Paso 3 — Alta anual',
        fields: [
          { label: 'Cultivo', description: 'Cultivo marcado como Anual en el catálogo.' },
          { label: 'Campaña', description: 'Campaña a la que pertenece la siembra.' },
          { label: 'Superficie (ha)', description: 'Hectáreas sembradas.' },
          { label: 'Fecha de siembra', description: 'Debe caer dentro de la campaña.' },
          { label: 'Estado', description: 'Planificada, Activa o Cosechada.' },
        ],
      },
      {
        title: 'Paso 4 — Alta perenne (ej. uva)',
        bullets: [
          'Elegí un cultivo Perenne: no se pide campaña.',
          'La fecha es de implantación (cuando se plantó el monte).',
          'Estados: Planificada, Activa o Removida (fin de vida del monte).',
          'No marques Cosechada en la plantación: la cosecha del año se registra como evento, en una temporada.',
        ],
      },
      {
        title: 'Temporadas (solo perennes)',
        bullets: [
          'Abrí el detalle de la plantación.',
          'En «Temporadas de producción» elegí una campaña y tocá «Abrir temporada».',
          'Así vinculás la cosecha 2025/26 al mismo viñedo sin crear otra plantación.',
          'En Eventos podés asociar un registro (cosecha, monitoreo…) a esa temporada.',
        ],
      },
    ],
  },
}
